var _style, _ellipse, _path, _g, _g2, _defs, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6SampleReceived({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#29384F;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{opacity:0.49;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#F0C15E;}\n\t.st4{fill:none;}\n")), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 106.6,
    cy: 106.1,
    rx: 77.1,
    ry: 76.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.4,122.9c7.5-6.9,7.8-21.1,7.8-35.1c14,1,28.2,1.7,35.7-5.3l-2.6-2.8c-0.4,0.4-0.9,0.8-1.4,1.1 c-0.6,0.4-1.3,0.8-2,1.2c-2,0.9-4.2,1.5-6.7,2c-0.9,0.2-1.9,0.3-2.8,0.4c-2.6,0.2-5.4,0.3-8.3,0.2c-1.1,0-2.1-0.1-3.2-0.1 c-2.8-0.1-5.6-0.3-8.5-0.5c0-2.8,0-5.7,0.1-8.5c0-1.1,0.1-2.2,0.1-3.2c0.2-2.9,0.4-5.7,0.8-8.2c0.2-0.9,0.4-1.9,0.6-2.8 c0.6-2.5,1.4-4.7,2.4-6.6c0.4-0.7,0.8-1.4,1.3-2c0.4-0.5,0.8-0.9,1.2-1.3l-2.6-2.8c-7.5,6.9-7.8,21.1-7.8,35.1 c-14-1-28.2-1.7-35.7,5.3c-7.5,7-7.8,21.1-7.8,35.1c-14-1-28.2-1.7-35.7,5.3l2.6,2.8c0.8-0.8,1.8-1.4,2.9-2c0.7-0.4,1.4-0.7,2.2-1 c2.1-0.8,4.5-1.2,7.1-1.5c1-0.1,1.9-0.2,2.9-0.2c2.7-0.2,5.6-0.1,8.5,0c1.1,0,2.2,0.1,3.3,0.2c2,0.1,4.1,0.3,6.1,0.4 c0,2,0,4.1,0,6.1c0,1.1-0.1,2.2-0.1,3.3c-0.1,2.9-0.3,5.8-0.6,8.5c-0.1,1-0.3,2-0.5,2.9c-0.5,2.6-1.1,4.9-2,7 c-0.3,0.8-0.7,1.5-1.1,2.1c-0.6,1-1.4,1.9-2.2,2.7l2.6,2.8c7.5-7,7.8-21.1,7.8-35.1C99.8,129.2,113.9,129.9,121.4,122.9z  M85.7,124.4c0-2.6,0-5.2,0.1-7.8c0-1.1,0.1-2.2,0.1-3.3c0.1-2.9,0.4-5.7,0.8-8.3c0.1-1,0.3-1.9,0.5-2.8c0.5-2.5,1.3-4.7,2.3-6.7 c0.4-0.7,0.8-1.4,1.3-2c0.5-0.6,1-1.2,1.5-1.7c1-0.9,2.1-1.6,3.3-2.2c0.7-0.4,1.5-0.7,2.3-0.9c2.1-0.7,4.6-1.2,7.2-1.4 c1-0.1,2-0.2,3-0.2c2.7-0.1,5.6-0.1,8.6,0c1.1,0.1,2.2,0.1,3.3,0.2c1.8,0.1,3.6,0.2,5.4,0.4c0,1.8,0,3.6,0,5.4c0,1.1,0,2.2-0.1,3.3 c-0.1,3-0.3,5.8-0.6,8.5c-0.1,1-0.2,2-0.4,2.9c-0.4,2.6-1.1,5-2,7.1c-0.3,0.8-0.7,1.5-1.1,2.2c-0.7,1.2-1.5,2.2-2.5,3.1 c-0.5,0.5-1.2,1-1.8,1.4c-0.7,0.4-1.4,0.8-2.1,1.1c-2,0.9-4.3,1.5-6.8,1.8c-0.9,0.1-1.9,0.2-2.9,0.3c-2.6,0.2-5.5,0.2-8.4,0.2 c-1.1,0-2.1-0.1-3.3-0.1C91,124.7,88.4,124.5,85.7,124.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.9,138.4l-9.6-10.3c1.1,0,2.3,0.1,3.4,0.2l6.3,6.7C81,136.2,81,137.3,80.9,138.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.8,150.2l-20.4-21.8c1-0.1,2-0.2,3-0.2l17.8,19C80.1,148.2,80,149.2,79.8,150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5,159.6L49.7,131c0.7-0.4,1.5-0.7,2.3-1l25.6,27.4C77.3,158.2,76.9,158.9,76.5,159.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.9,80c-0.7,0.5-1.4,0.9-2.1,1.2l-26.4-28.3c0.4-0.7,0.9-1.4,1.4-2L162.9,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.8,83.3c-1,0.2-1.9,0.3-2.9,0.4l-19.7-21.1c0.2-1,0.4-2,0.6-2.9L153.8,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,83.9c-1.1,0-2.2-0.1-3.4-0.1l-8.7-9.3c0-1.1,0.1-2.2,0.1-3.3L142.2,83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.4,122.1c-0.7,0.4-1.4,0.8-2.2,1.1L89,95.2c0.4-0.8,0.8-1.5,1.3-2.1L117.4,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126,95.9l-8.9-9.5c1.1,0.1,2.3,0.1,3.4,0.2l5.6,6C126.1,93.7,126,94.8,126,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125,107.8l-19.8-21.2c1-0.1,2-0.2,3.1-0.2l17.2,18.4C125.3,105.8,125.1,106.8,125,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.8,117.4L95.3,89c0.7-0.4,1.5-0.7,2.4-0.9l25.3,27C122.6,115.9,122.2,116.7,121.8,117.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.5,125.7c-1.1,0-2.2-0.1-3.4-0.1l-8-8.5c0-1.1,0.1-2.2,0.1-3.4L96.5,125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.1,125.1c-1,0.1-2,0.2-3,0.3L86,105c0.2-1,0.3-2,0.5-2.9L108.1,125.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.6,84.3c12.2,12.4,11.9,32.2-0.5,44.3s-32.4,11.9-44.5-0.5c-12.2-12.4-11.9-32.2,0.5-44.3 C96.5,71.7,116.4,71.9,128.6,84.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    cx: 106.6,
    cy: 106.1,
    rx: 77.1,
    ry: 76.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M191.4,185.6l-56-54.3c0.4-0.5,0.8-0.9,1.2-1.4c11.7-15,10.8-36.6-2.9-50.5c-14.9-15.2-39.4-15.4-54.6-0.6 c-15.2,14.8-15.5,39.2-0.6,54.4c13.7,13.9,35.4,15.3,50.6,4c0.5-0.4,1-0.8,1.5-1.2l53.4,57c2,2,5.3,2.1,7.4,0.1 C193.4,190.9,193.4,187.6,191.4,185.6z M83.6,128.1c-12.2-12.4-11.9-32.2,0.5-44.3s32.4-11.9,44.5,0.5s11.9,32.2-0.5,44.3 S95.8,140.5,83.6,128.1z"
  })))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.8,119.3c0,0-0.2,0.1-0.4,0.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6SampleReceived);
export default __webpack_public_path__ + "static/media/6SampleReceived.23ffeb7be18e1329987e80335f599117.svg";
export { ForwardRef as ReactComponent };